import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { RadarReflectivitySvgComponent } from './winter-radar-reflectivity-legend/winter-radar-reflectivity-legend-svg';

export const WINTER_RADAR_MOSAIC_LEGEND: TwcLegendParams = {
  title: 'RADAR REFLECTIVITY',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: RadarReflectivitySvgComponent },
  legendComponent: TwcLegendComponent
};
